module.exports = __webpack_public_path__ + "8ea112660b9307994997bf787080bc61.svg";